import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { Autocomplete, FormField, Typography } from "@maysoft/common-component-react";

import Strings from "constants/strings";

import Constants from "constants/index";
import { Mode } from "constants/enum";
import { ICodename, IDataDetailAnalysis, IErrorAnalysis } from "commons/interfaces";



export const CardCause = ({
    mode,
    dataOptions,
    dataAnalysis,
    errorAnalysis,
    handleChangeValue,
}: {
    mode: Mode,
    errorAnalysis: IErrorAnalysis;
    dataAnalysis: IDataDetailAnalysis;
    handleChangeValue: (key: string, value: any) => void;
    dataOptions: {
        causeGroup: ICodename[];
        staffCaused: ICodename[];
        patientCaused: ICodename[];
        serviceCaused: ICodename[];
        environmentCaused: ICodename[];
        externalFactorCaused: ICodename[];
    };
}) => {

    const renderCauseGroupDetail = (code: string) => {
        switch (code) {
            case "staff":
                return (
                    <Autocomplete
                        mode={mode}
                        variant={"outlined"}
                        data={dataOptions.staffCaused || []}
                        label={Strings.ANALYSIS.CAUSE_GROUP_1}
                        placeholder={Strings.COMMON.SELECT_VALUE}
                        defaultValue={dataAnalysis?.causeGroupDetail}
                        errorMessage={errorAnalysis?.causeGroupDetail}
                        onChange={(value) => {
                            handleChangeValue("causeGroupDetail", value);
                        }}
                    />
                );
            case "patient":
                return (
                    <Autocomplete
                        mode={mode}
                        variant={"outlined"}
                        label={Strings.ANALYSIS.CAUSE_GROUP_2}
                        data={dataOptions.patientCaused || []}
                        placeholder={Strings.COMMON.SELECT_VALUE}
                        defaultValue={dataAnalysis?.causeGroupDetail}
                        errorMessage={errorAnalysis?.causeGroupDetail}
                        onChange={(value) => {
                            handleChangeValue("causeGroupDetail", value);
                        }}
                    />
                );
            case "environment":
                return (
                    <Autocomplete
                        mode={mode}
                        variant={"outlined"}
                        label={Strings.ANALYSIS.CAUSE_GROUP_3}
                        data={dataOptions.environmentCaused || []}
                        placeholder={Strings.COMMON.SELECT_VALUE}
                        defaultValue={dataAnalysis?.causeGroupDetail}
                        errorMessage={errorAnalysis?.causeGroupDetail}
                        onChange={(value) => {
                            handleChangeValue("causeGroupDetail", value);
                        }}
                    />
                );
            case "service":
                return (
                    <Autocomplete
                        mode={mode}
                        variant={"outlined"}
                        label={Strings.ANALYSIS.CAUSE_GROUP_4}
                        data={dataOptions.serviceCaused || []}
                        placeholder={Strings.COMMON.SELECT_VALUE}
                        defaultValue={dataAnalysis?.causeGroupDetail}
                        errorMessage={errorAnalysis?.causeGroupDetail}
                        onChange={(value) => {
                            handleChangeValue("causeGroupDetail", value);
                        }}
                    />
                );
            case "externalFactor":
                return (
                    <Autocomplete
                        mode={mode}
                        variant={"outlined"}
                        label={Strings.ANALYSIS.CAUSE_GROUP_5}
                        placeholder={Strings.COMMON.SELECT_VALUE}
                        defaultValue={dataAnalysis?.causeGroupDetail}
                        data={dataOptions.externalFactorCaused || []}
                        errorMessage={errorAnalysis?.causeGroupDetail}
                        onChange={(value) => {
                            handleChangeValue("causeGroupDetail", value);
                        }}
                    />
                );
            case "otherFactor":
                return (
                    <FormField
                        mode={mode}
                        variant={"outlined"}
                        placeholder={Strings.COMMON.ENTER_VALUE}
                        errorMessage={errorAnalysis?.causeGroupDetail}
                        defaultValue={dataAnalysis?.causeGroupDetail || ""}
                        onBlur={(value) => {
                            handleChangeValue("causeGroupDetail", value);
                        }}
                    />
                );
            default:
                return null;
        }
    };

    return (
        <Card sx={{ padding: 3 }}>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        {Strings.ANALYSIS.CAUSE}
                    </Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Autocomplete
                        mode={mode}
                        variant={"outlined"}
                        data={dataOptions.causeGroup}
                        label={Strings.ANALYSIS.INCIDENT_CAUSE}
                        defaultValue={dataAnalysis?.causeGroup}
                        errorMessage={errorAnalysis?.causeGroup}
                        placeholder={Strings.ANALYSIS.SELECT_INCIDENT_CAUSE}
                        onChange={(value) => {
                            handleChangeValue("causeGroup", value);
                        }}
                    />
                </Grid>

                {dataAnalysis?.causeGroup &&
                    <Grid item xs={12} sm={6}>
                        {renderCauseGroupDetail(dataAnalysis?.causeGroup)}
                    </Grid>
                }

                <Grid item xs={12} sm={12}>
                    <FormField
                        multiline
                        mode={mode}
                        minRows={3}
                        maxRows={30}
                        variant={"outlined"}
                        maxLength={Constants.CHAR_MAX_LENGTH.REPORT}
                        label={Strings.ANALYSIS.ROOT_CAUSE + ` (${Strings.formatString(Strings.MESSAGE.CHAR_MAX_LENGTH, Constants.CHAR_MAX_LENGTH.REPORT)})`}
                        placeholder={Strings.COMMON.ENTER_VALUE}
                        defaultValue={dataAnalysis?.rootCause || ""}
                        errorMessage={errorAnalysis?.rootCause || ""}
                        onBlur={(value) => {
                            handleChangeValue("rootCause", value);
                        }}
                    />
                </Grid>
            </Grid>
        </Card>
    );
};

export default CardCause;
